import { NWA_QRCode } from 'nwa-qrcode';
import React, { useEffect, useRef, useState } from 'react';
import { Redirect, useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { useEvent } from '../../../data/hooks/eventHooks';
import { useI18n } from '../../../data/hooks/i18nHooks';
import Scrollable from '../../elements/Scrollable';
import TopBarEvent from '../../elements/TopBar/TopBarEvent';
import Screen from '../Screen';
import { useEventSettings } from '../../../data/hooks/events/useEventSettings';
import styles from './EventQRCode.module.scss';

function EventQRCode(props) {
    const { eventId } = props,
        event = useEvent(eventId),
        settings = useEventSettings(eventId),
        { qr_code } = event,
        i18n = useI18n(),
        ref = useRef(),
        [width, setWidth] = useState(0);

    // update size
    useEffect(() => {
        function updateMeasurement() {
            if (ref.current) {
                const width = Math.floor(ref.current.getBoundingClientRect().width);

                setWidth((currentWidth) => (currentWidth === width ? currentWidth : width));
            }
        }

        updateMeasurement();
        window.addEventListener('resize', updateMeasurement);
        return () => window.removeEventListener('resize', updateMeasurement);
    });

    // render screen
    const header = <TopBarEvent event={event}>{settings.qr_code_label}</TopBarEvent>;

    return (
        <Screen className={styles.EventQRCode} header={header}>
            <Scrollable>
                <div className="content" ref={ref}>
                    <div className={styles.description}>{settings.qr_code_description}</div>
                    <div className={styles.qrCodeWrapper} style={{ width: 0.8 * width, height: 0.8 * width }}>
                        <NWA_QRCode className={styles.qrCode} value={qr_code} size={0.6 * width} logo={false} />
                    </div>
                    <div className={styles.codeContent}>{event.qr_code}</div>
                    <div className={styles.instructions}>{i18n['label.qr_code_instruction']}</div>
                </div>
            </Scrollable>
        </Screen>
    );
}

export default (props) => {
    const { eventId } = useParams(),
        event = useEvent(eventId);

    if (!event?.qr_code) {
        console.log('No QR code to show');
        return <Redirect to=".." />;
    }

    return <EventQRCode eventId={eventId} />;
};
